import Vue from 'vue/dist/vue.esm'

function registerClosableDirective() {
  // The following directive is based on
  // https://tahazsh.com/detect-outside-click-in-vue

  // This variable will hold the reference to
  // document's click handler
  let handleOutsideClick;

  Vue.directive('closable', {
    bind(el, binding, vnode) {
      const { exclude, handler } = binding.value;

      if (handler === undefined || handler === null || typeof handler !== 'function') {
        throw new Error("Must specify a 'handler' function when using v-closable Vue directive");
      }

      handleOutsideClick = function _handOutsideClick(e) {
        e.stopPropagation();

        let clickedOnExcludedEl = false;
        const elementsExcludedFromClosing = exclude || [];

        elementsExcludedFromClosing.forEach((refName) => {
          // We only run this code if we haven't detected
          // any excluded element yet
          if (!clickedOnExcludedEl) {
            // Get the element using the reference name
            const excludedEl = vnode.context.$refs[refName];
            // See if this excluded element
            // is the same element the user just clicked on
            clickedOnExcludedEl = excludedEl.$el.contains(e.target);
          }
        });

        // We check to see if the clicked element is not
        // the closable element and not excluded
        if (!el.contains(e.target) && !clickedOnExcludedEl) {
          // If the clicked element is outside the closable element
          // and not excluded, then call the outside-click handler
          // from the same component this directive is used in
          handler();
        }
      };

      // Register click/touchstart event listeners on the whole page
      document.addEventListener('click', handleOutsideClick);
      document.addEventListener('touchstart', handleOutsideClick);
    },

    unbind() {
      // If the element that has v-closable is removed, then
      // unbind click/touchstart listeners from the whole page
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    }
  });
}

export default registerClosableDirective;
